import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthDataAccess } from 'src/app/auth/data-access/auth.data-access';

export const publicGuard: CanActivateFn = () => {
  const auth = inject(AuthDataAccess);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
